import { render, staticRenderFns } from "./FeatureGuard.vue?vue&type=template&id=3d60f04f&"
import script from "./FeatureGuard.vue?vue&type=script&lang=js&"
export * from "./FeatureGuard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports